// Quicar na Horizontal - alwaysBounceHorizontal
type Tprops_alwaysBounceHorizontal = {
  pass: { alwaysBounceHorizontal: any; B: any; C: any; D: any; args: any };
};
export const alwaysBounceHorizontal = (
  props: Tprops_alwaysBounceHorizontal,
) => {
  const { alwaysBounceHorizontal, B, C, D, args } = props.pass;

  console.log({ alwaysBounceHorizontal });

  // return; aqui fica comentado por enquanto
};
// Quicar na Vertical - alwaysBounceVertical
type Tprops_alwaysBounceVertical = {
  pass: { alwaysBounceVertical: any; B: any; C: any; D: any; args: any };
};
export const alwaysBounceVertical = (props: Tprops_alwaysBounceVertical) => {
  const { alwaysBounceVertical, B, C, D, args } = props.pass;

  console.log({ alwaysBounceVertical });

  // return; aqui fica comentado por enquanto
};
// Quicar - bounces
type Tprops_bounces = {
  pass: { bounces: any; B: any; C: any; D: any; args: any };
};
export const bounces = (props: Tprops_bounces) => {
  const { bounces, B, C, D, args } = props.pass;

  console.log({ bounces });

  // return; aqui fica comentado por enquanto
};
// Animação de Zoom - bouncesZoom
type Tprops_bouncesZoom = {
  pass: { bouncesZoom: any; B: any; C: any; D: any; args: any };
};
export const bouncesZoom = (props: Tprops_bouncesZoom) => {
  const { bouncesZoom, B, C, D, args } = props.pass;

  console.log({ bouncesZoom });

  // return; aqui fica comentado por enquanto
};
// Ajuste automático da inserção de conteúdo - automaticallyAdjustContentInsets
type Tprops_automaticallyAdjustContentInsets = {
  pass: {
    automaticallyAdjustContentInsets: any;
    B: any;
    C: any;
    D: any;
    args: any;
  };
};
export const automaticallyAdjustContentInsets = (
  props: Tprops_automaticallyAdjustContentInsets,
) => {
  const { automaticallyAdjustContentInsets, B, C, D, args } = props.pass;

  console.log({ automaticallyAdjustContentInsets });

  // return; aqui fica comentado por enquanto
};
// Ajuste automático ao tamanho do teclado - automaticallyAdjustKeyboardInsets
type Tprops_automaticallyAdjustKeyboardInsets = {
  pass: {
    automaticallyAdjustKeyboardInsets: any;
    B: any;
    C: any;
    D: any;
    args: any;
  };
};
export const automaticallyAdjustKeyboardInsets = (
  props: Tprops_automaticallyAdjustKeyboardInsets,
) => {
  const { automaticallyAdjustKeyboardInsets, B, C, D, args } = props.pass;

  console.log({ automaticallyAdjustKeyboardInsets });

  // return; aqui fica comentado por enquanto
};
// Ajustar automático das inserções do indicador de rolagem - automaticallyAdjustsScrollIndicatorInsets
type Tprops_automaticallyAdjustsScrollIndicatorInsets = {
  pass: {
    automaticallyAdjustsScrollIndicatorInsets: any;
    B: any;
    C: any;
    D: any;
    args: any;
  };
};
export const automaticallyAdjustsScrollIndicatorInsets = (
  props: Tprops_automaticallyAdjustsScrollIndicatorInsets,
) => {
  const { automaticallyAdjustsScrollIndicatorInsets, B, C, D, args } =
    props.pass;

  console.log({ automaticallyAdjustsScrollIndicatorInsets });

  // return; aqui fica comentado por enquanto
};
// Ignorar movimento no Touch - canCancelContentTouches
type Tprops_canCancelContentTouches = {
  pass: { canCancelContentTouches: any; B: any; C: any; D: any; args: any };
};
export const canCancelContentTouches = (
  props: Tprops_canCancelContentTouches,
) => {
  const { canCancelContentTouches, B, C, D, args } = props.pass;

  console.log({ canCancelContentTouches });

  // return; aqui fica comentado por enquanto
};
// Centralizar Conteúdo - centerContent
type Tprops_centerContent = {
  pass: { centerContent: any; B: any; C: any; D: any; args: any };
};
export const centerContent = (props: Tprops_centerContent) => {
  const { centerContent, B, C, D, args } = props.pass;

  console.log({ centerContent });

  // return; aqui fica comentado por enquanto
};
// Estilo de Conteúdo do Container - contentContainerStyle
type Tprops_contentContainerStyle = {
  pass: { contentContainerStyle: any; B: any; C: any; D: any; args: any };
};
export const contentContainerStyle = (props: Tprops_contentContainerStyle) => {
  const { contentContainerStyle, B, C, D, args } = props.pass;

  console.log({ contentContainerStyle });

  // return; aqui fica comentado por enquanto
};
// Posicionamento do Conteúdo - contentInset
type Tprops_contentInset = {
  pass: { contentInset: any; B: any; C: any; D: any; args: any };
};
export const contentInset = (props: Tprops_contentInset) => {
  const { contentInset, B, C, D, args } = props.pass;

  console.log({ contentInset });

  // return; aqui fica comentado por enquanto
};
// Posicionamento do Conteúdo na Área Segura - contentInsetAdjustmentBehavior
type Tprops_contentInsetAdjustmentBehavior = {
  pass: {
    contentInsetAdjustmentBehavior: any;
    B: any;
    C: any;
    D: any;
    args: any;
  };
};
export const contentInsetAdjustmentBehavior = (
  props: Tprops_contentInsetAdjustmentBehavior,
) => {
  const { contentInsetAdjustmentBehavior, B, C, D, args } = props.pass;

  console.log({ contentInsetAdjustmentBehavior });

  // return; aqui fica comentado por enquanto
};
// Deslocamento de rolagem inicial - contentOffset
type Tprops_contentOffset = {
  pass: { contentOffset: any; B: any; C: any; D: any; args: any };
};
export const contentOffset = (props: Tprops_contentOffset) => {
  const { contentOffset, B, C, D, args } = props.pass;

  console.log({ contentOffset });

  // return; aqui fica comentado por enquanto
};
// Taxa de desaceleração - decelerationRate
type Tprops_decelerationRate = {
  pass: { decelerationRate: any; B: any; C: any; D: any; args: any };
};
export const decelerationRate = (props: Tprops_decelerationRate) => {
  const { decelerationRate, B, C, D, args } = props.pass;

  console.log({ decelerationRate });

  // return; aqui fica comentado por enquanto
};
// Bloqueio de Rolagem Direcional - directionalLockEnabled
type Tprops_directionalLockEnabled = {
  pass: { directionalLockEnabled: any; B: any; C: any; D: any; args: any };
};
export const directionalLockEnabled = (
  props: Tprops_directionalLockEnabled,
) => {
  const { directionalLockEnabled, B, C, D, args } = props.pass;

  console.log({ directionalLockEnabled });

  // return; aqui fica comentado por enquanto
};
// Navegação por índices - disableIntervalMomentum
type Tprops_disableIntervalMomentum = {
  pass: { disableIntervalMomentum: any; B: any; C: any; D: any; args: any };
};
export const disableIntervalMomentum = (
  props: Tprops_disableIntervalMomentum,
) => {
  const { disableIntervalMomentum, B, C, D, args } = props.pass;

  console.log({ disableIntervalMomentum });

  // return; aqui fica comentado por enquanto
};
// Desabilitar  controle de toques da View - disableScrollViewPanResponder
type Tprops_disableScrollViewPanResponder = {
  pass: {
    disableScrollViewPanResponder: any;
    B: any;
    C: any;
    D: any;
    args: any;
  };
};
export const disableScrollViewPanResponder = (
  props: Tprops_disableScrollViewPanResponder,
) => {
  const { disableScrollViewPanResponder, B, C, D, args } = props.pass;

  console.log({ disableScrollViewPanResponder });

  // return; aqui fica comentado por enquanto
};
// Cor de preenchimento da rolagem - endFillColor
type Tprops_endFillColor = {
  pass: { endFillColor: any; B: any; C: any; D: any; args: any };
};
export const endFillColor = (props: Tprops_endFillColor) => {
  const { endFillColor, B, C, D, args } = props.pass;

  console.log({ endFillColor });

  // return; aqui fica comentado por enquanto
};
// Cor de preenchimento da rolagem - fadingEdgeLength
type Tprops_fadingEdgeLength = {
  pass: { fadingEdgeLength: any; B: any; C: any; D: any; args: any };
};
export const fadingEdgeLength = (props: Tprops_fadingEdgeLength) => {
  const { fadingEdgeLength, B, C, D, args } = props.pass;

  console.log({ fadingEdgeLength });

  // return; aqui fica comentado por enquanto
};
// Horizontal - horizontal
type Tprops_horizontal = {
  pass: { horizontal: any; B: any; C: any; D: any; args: any };
};
export const horizontal2 = (props: Tprops_horizontal) => {
  const { horizontal, B, C, D, args } = props.pass;

  console.log({ horizontal });

  // return; aqui fica comentado por enquanto
};
//  Estilo dos indicadores - indicatorStyle
type Tprops_indicatorStyle = {
  pass: { indicatorStyle: any; B: any; C: any; D: any; args: any };
};
export const indicatorStyle = (props: Tprops_indicatorStyle) => {
  const { indicatorStyle, B, C, D, args } = props.pass;

  console.log({ indicatorStyle });

  // return; aqui fica comentado por enquanto
};
//  Inverter Cabeçalho - invertStickyHeaders
type Tprops_invertStickyHeaders = {
  pass: { invertStickyHeaders: any; B: any; C: any; D: any; args: any };
};
export const invertStickyHeaders = (props: Tprops_invertStickyHeaders) => {
  const { invertStickyHeaders, B, C, D, args } = props.pass;

  console.log({ invertStickyHeaders });

  // return; aqui fica comentado por enquanto
};
//  Descartar Teclado - keyboardDismissMode
type Tprops_keyboardDismissMode = {
  pass: { keyboardDismissMode: any; B: any; C: any; D: any; args: any };
};
export const keyboardDismissMode = (props: Tprops_keyboardDismissMode) => {
  const { keyboardDismissMode, B, C, D, args } = props.pass;

  console.log({ keyboardDismissMode });

  // return; aqui fica comentado por enquanto
};
//  Teclado Segue Visível - keyboardShouldPersistTaps
type Tprops_keyboardShouldPersistTaps = {
  pass: { keyboardShouldPersistTaps: any; B: any; C: any; D: any; args: any };
};
export const keyboardShouldPersistTaps = (
  props: Tprops_keyboardShouldPersistTaps,
) => {
  const { keyboardShouldPersistTaps, B, C, D, args } = props.pass;

  console.log({ keyboardShouldPersistTaps });

  // return; aqui fica comentado por enquanto
};
//  Fixar Posição do Conteúdo Visível - maintainVisibleContentPosition
type Tprops_maintainVisibleContentPosition = {
  pass: {
    maintainVisibleContentPosition: any;
    B: any;
    C: any;
    D: any;
    args: any;
  };
};
export const maintainVisibleContentPosition = (
  props: Tprops_maintainVisibleContentPosition,
) => {
  const { maintainVisibleContentPosition, B, C, D, args } = props.pass;

  console.log({ maintainVisibleContentPosition });

  // return; aqui fica comentado por enquanto
};
//  Escala máxima de Zoom - maximumZoomScale
type Tprops_maximumZoomScale = {
  pass: { maximumZoomScale: any; B: any; C: any; D: any; args: any };
};
export const maximumZoomScale = (props: Tprops_maximumZoomScale) => {
  const { maximumZoomScale, B, C, D, args } = props.pass;

  console.log({ maximumZoomScale });

  // return; aqui fica comentado por enquanto
};
//  Escala mínima de Zoom - minimumZoomScale
type Tprops_minimumZoomScale = {
  pass: { minimumZoomScale: any; B: any; C: any; D: any; args: any };
};
export const minimumZoomScale = (props: Tprops_minimumZoomScale) => {
  const { minimumZoomScale, B, C, D, args } = props.pass;

  console.log({ minimumZoomScale });

  // return; aqui fica comentado por enquanto
};
//  Rolagem aninhada - nestedScrollEnabled
type Tprops_nestedScrollEnabled = {
  pass: { nestedScrollEnabled: any; B: any; C: any; D: any; args: any };
};
export const nestedScrollEnabled = (props: Tprops_nestedScrollEnabled) => {
  const { nestedScrollEnabled, B, C, D, args } = props.pass;

  console.log({ nestedScrollEnabled });

  // return; aqui fica comentado por enquanto
};
//  Substituição do overScroll - overScrollMode
type Tprops_overScrollMode = {
  pass: { overScrollMode: any; B: any; C: any; D: any; args: any };
};
export const overScrollMode = (props: Tprops_overScrollMode) => {
  const { overScrollMode, B, C, D, args } = props.pass;

  console.log({ overScrollMode });

  // return; aqui fica comentado por enquanto
};
//  Habilitar paginação - pagingEnabled
type Tprops_pagingEnabled = {
  pass: { pagingEnabled: any; B: any; C: any; D: any; args: any };
};
export const pagingEnabled = (props: Tprops_pagingEnabled) => {
  const { pagingEnabled, B, C, D, args } = props.pass;

  console.log({ pagingEnabled });

  // return; aqui fica comentado por enquanto
};
//  Manter barra de rolagem - persistentScrollbar
type Tprops_persistentScrollbar = {
  pass: { persistentScrollbar: any; B: any; C: any; D: any; args: any };
};
export const persistentScrollbar = (props: Tprops_persistentScrollbar) => {
  const { persistentScrollbar, B, C, D, args } = props.pass;

  console.log({ persistentScrollbar });

  // return; aqui fica comentado por enquanto
};
//  Gestos de pinça para Zoom - pinchGestureEnabled
type Tprops_pinchGestureEnabled = {
  pass: { pinchGestureEnabled: any; B: any; C: any; D: any; args: any };
};
export const pinchGestureEnabled = (props: Tprops_pinchGestureEnabled) => {
  const { pinchGestureEnabled, B, C, D, args } = props.pass;

  console.log({ pinchGestureEnabled });

  // return; aqui fica comentado por enquanto
};
//  Remoção de Subvisualização Cortada - removeClippedSubviews
type Tprops_removeClippedSubviews = {
  pass: { removeClippedSubviews: any; B: any; C: any; D: any; args: any };
};
export const removeClippedSubviews = (props: Tprops_removeClippedSubviews) => {
  const { removeClippedSubviews, B, C, D, args } = props.pass;

  console.log({ removeClippedSubviews });

  // return; aqui fica comentado por enquanto
};
// Habilitar rolagem - scrollEnabled
type Tprops_scrollEnabled = {
  pass: { scrollEnabled: any; B: any; C: any; D: any; args: any };
};
export const scrollEnabled = (props: Tprops_scrollEnabled) => {
  const { scrollEnabled, B, C, D, args } = props.pass;

  console.log({ scrollEnabled });

  // return; aqui fica comentado por enquanto
};
// Disparador de evento de rolagem - scrollEventThrottle
type Tprops_scrollEventThrottle = {
  pass: { scrollEventThrottle: any; B: any; C: any; D: any; args: any };
};
export const scrollEventThrottle = (props: Tprops_scrollEventThrottle) => {
  const { scrollEventThrottle, B, C, D, args } = props.pass;

  console.log({ scrollEventThrottle });

  // return; aqui fica comentado por enquanto
};
// Inserção de Indicadores de Rolagem - scrollIndicatorInsets
type Tprops_scrollIndicatorInsets = {
  pass: { scrollIndicatorInsets: any; B: any; C: any; D: any; args: any };
};
export const scrollIndicatorInsets = (props: Tprops_scrollIndicatorInsets) => {
  const { scrollIndicatorInsets, B, C, D, args } = props.pass;

  console.log({ scrollIndicatorInsets });

  // return; aqui fica comentado por enquanto
};
// Rolar além do conteúdo - scrollToOverflowEnabled
type Tprops_scrollToOverflowEnabled = {
  pass: { scrollToOverflowEnabled: any; B: any; C: any; D: any; args: any };
};
export const scrollToOverflowEnabled = (
  props: Tprops_scrollToOverflowEnabled,
) => {
  const { scrollToOverflowEnabled, B, C, D, args } = props.pass;

  console.log({ scrollToOverflowEnabled });

  // return; aqui fica comentado por enquanto
};
// Voltar ao Topo - scrollsToTop
type Tprops_scrollsToTop = {
  pass: { scrollsToTop: any; B: any; C: any; D: any; args: any };
};
export const scrollsToTop = (props: Tprops_scrollsToTop) => {
  const { scrollsToTop, B, C, D, args } = props.pass;

  console.log({ scrollsToTop });

  // return; aqui fica comentado por enquanto
};
// Mostrar Barra Horizontal - showsHorizontalScrollIndicator
type Tprops_showsHorizontalScrollIndicator = {
  pass: {
    showsHorizontalScrollIndicator: any;
    B: any;
    C: any;
    D: any;
    args: any;
  };
};
export const showsHorizontalScrollIndicator = (
  props: Tprops_showsHorizontalScrollIndicator,
) => {
  const { showsHorizontalScrollIndicator, B, C, D, args } = props.pass;

  console.log({ showsHorizontalScrollIndicator });

  // return; aqui fica comentado por enquanto
};
// Mostrar Barra Vertical - ShowsVerticalScrollIndicator
type Tprops_ShowsVerticalScrollIndicator = {
  pass: {
    ShowsVerticalScrollIndicator: any;
    B: any;
    C: any;
    D: any;
    args: any;
  };
};
export const ShowsVerticalScrollIndicator = (
  props: Tprops_ShowsVerticalScrollIndicator,
) => {
  const { ShowsVerticalScrollIndicator, B, C, D, args } = props.pass;

  console.log({ ShowsVerticalScrollIndicator });

  // return; aqui fica comentado por enquanto
};
// Encaixar ao Alinhamento - snapToAlignment
type Tprops_snapToAlignment = {
  pass: { snapToAlignment: any; B: any; C: any; D: any; args: any };
};
export const snapToAlignment = (props: Tprops_snapToAlignment) => {
  const { snapToAlignment, B, C, D, args } = props.pass;

  console.log({ snapToAlignment });

  // return; aqui fica comentado por enquanto
};
// Desativar Encaixe Final - snapToEnd
type Tprops_snapToEnd = {
  pass: { snapToEnd: any; B: any; C: any; D: any; args: any };
};
export const snapToEnd = (props: Tprops_snapToEnd) => {
  const { snapToEnd, B, C, D, args } = props.pass;

  console.log({ snapToEnd });

  // return; aqui fica comentado por enquanto
};
// Encaixar ao Intervalo - snapToInterval
type Tprops_snapToInterval = {
  pass: { snapToInterval: any; B: any; C: any; D: any; args: any };
};
export const snapToInterval = (props: Tprops_snapToInterval) => {
  const { snapToInterval, B, C, D, args } = props.pass;

  console.log({ snapToInterval });

  // return; aqui fica comentado por enquanto
};
// Encaixar ao Deslocamento - snapToOffsets
type Tprops_snapToOffsets = {
  pass: { snapToOffsets: any; B: any; C: any; D: any; args: any };
};
export const snapToOffsets = (props: Tprops_snapToOffsets) => {
  const { snapToOffsets, B, C, D, args } = props.pass;

  console.log({ snapToOffsets });

  // return; aqui fica comentado por enquanto
};
// Desativar Encaixe ao Início - snapToStart
type Tprops_snapToStart = {
  pass: { snapToStart: any; B: any; C: any; D: any; args: any };
};
export const snapToStart = (props: Tprops_snapToStart) => {
  const { snapToStart, B, C, D, args } = props.pass;

  console.log({ snapToStart });

  // return; aqui fica comentado por enquanto
};
// Ocultar Cabeçalho ao Rolar - stickyHeaderHiddenOnScroll
type Tprops_stickyHeaderHiddenOnScroll = {
  pass: { stickyHeaderHiddenOnScroll: any; B: any; C: any; D: any; args: any };
};
export const stickyHeaderHiddenOnScroll = (
  props: Tprops_stickyHeaderHiddenOnScroll,
) => {
  const { stickyHeaderHiddenOnScroll, B, C, D, args } = props.pass;

  console.log({ stickyHeaderHiddenOnScroll });

  // return; aqui fica comentado por enquanto
};
// Matriz de Índices - stickyHeaderIndices
type Tprops_stickyHeaderIndices = {
  pass: { stickyHeaderIndices: any; B: any; C: any; D: any; args: any };
};
export const stickyHeaderIndices = (props: Tprops_stickyHeaderIndices) => {
  const { stickyHeaderIndices, B, C, D, args } = props.pass;

  console.log({ stickyHeaderIndices });

  // return; aqui fica comentado por enquanto
};
// Escala do Conteúdo - zoomScale
type Tprops_zoomScale = {
  pass: { zoomScale: any; B: any; C: any; D: any; args: any };
};
export const zoomScale = (props: Tprops_zoomScale) => {
  const { zoomScale, B, C, D, args } = props.pass;

  console.log({ zoomScale });

  // return; aqui fica comentado por enquanto
};
//  Ao parar de arrastar rolagem - onScrollEndDrag
type Tprops_onScrollEndDrag = {
  pass: { onScrollEndDrag: any; B: any; C: any; D: any; args: any };
};
export const onScrollEndDrag = (props: Tprops_onScrollEndDrag) => {
  const { onScrollEndDrag, B, C, D, args } = props.pass;

  console.log({ onScrollEndDrag });

  // return; aqui fica comentado por enquanto
};
// Etiqueta de Rolagem - scrollPerfTag
type Tprops_scrollPerfTagg = {
  pass: { scrollPerfTag: any; B: any; C: any; D: any; args: any };
};
export const scrollPerfTagg = (props: Tprops_scrollPerfTagg) => {
  const { scrollPerfTag, B, C, D, args } = props.pass;

  console.log({ scrollPerfTag });

  // return; aqui fica comentado por enquanto
};
//  Controle de Atualização - refreshControl
type Tprops_refreshControl = {
  pass: { refreshControl: any; B: any; C: any; D: any; args: any };
};
export const refreshControl = (props: Tprops_refreshControl) => {
  const { refreshControl, B, C, D, args } = props.pass;

  console.log({ refreshControl });

  // return; aqui fica comentado por enquanto
};
//  Ajuste ao mudar tamanho do conteúdo - onContentSizeChange
type Tprops_onContentSizeChange = {
  pass: { onContentSizeChange: any; B: any; C: any; D: any; args: any };
};
export const onContentSizeChange = (props: Tprops_onContentSizeChange) => {
  const { onContentSizeChange, B, C, D, args } = props.pass;

  console.log({ onContentSizeChange });

  // return; aqui fica comentado por enquanto
};
//  Função ao começar rolagem - onMomentumScrollBegin
type Tprops_onMomentumScrollBegin = {
  pass: { onMomentumScrollBegin: any; B: any; C: any; D: any; args: any };
};
export const onMomentumScrollBegin = (props: Tprops_onMomentumScrollBegin) => {
  const { onMomentumScrollBegin, B, C, D, args } = props.pass;

  console.log({ onMomentumScrollBegin });

  // return; aqui fica comentado por enquanto
};
//  Função ao terminar rolagem - onMomentumScrollEnd
type Tprops_onMomentumScrollEnd = {
  pass: { onMomentumScrollEnd: any; B: any; C: any; D: any; args: any };
};
export const onMomentumScrollEnd = (props: Tprops_onMomentumScrollEnd) => {
  const { onMomentumScrollEnd, B, C, D, args } = props.pass;

  console.log({ onMomentumScrollEnd });

  // return; aqui fica comentado por enquanto
};
//  Ao rolar - onScroll
type Tprops_onScroll = {
  pass: { onScroll: any; B: any; C: any; D: any; args: any };
};
export const onScroll = (props: Tprops_onScroll) => {
  const { onScroll, B, C, D, args } = props.pass;

  console.log({ onScroll });

  // return; aqui fica comentado por enquanto
};
//  Ao arrastar rolagem - onScrollBeginDrag
type Tprops_onScrollBeginDrag = {
  pass: { onScrollBeginDrag: any; B: any; C: any; D: any; args: any };
};
export const onScrollBeginDrag = (props: Tprops_onScrollBeginDrag) => {
  const { onScrollBeginDrag, B, C, D, args } = props.pass;

  console.log({ onScrollBeginDrag });

  // return; aqui fica comentado por enquanto
};
//  Ao rolar para cima - onScrollToTop
type Tprops_onScrollToTop = {
  pass: { onScrollToTop: any; B: any; C: any; D: any; args: any };
};
export const onScrollToTop = (props: Tprops_onScrollToTop) => {
  const { onScrollToTop, B, C, D, args } = props.pass;

  console.log({ onScrollToTop });

  // return; aqui fica comentado por enquanto
};
// Estilo - style
type Tprops_style = {
  pass: { style: any; B: any; C: any; D: any; args: any };
};
export const style = (props: Tprops_style) => {
  const { style, B, C, D, args } = props.pass;

  console.log({ style });

  // return; aqui fica comentado por enquanto
};

// ######################################
// ######################################
// FALTA REVISAR E  RENOMEAR AS ENTRADAS
// CONTINUAR DA LINHA 181
// ######################################
// ######################################

// --------------------------------------
// --------------------------------------
// --------------------------------------
